import React from 'react';

import './index.scss';
interface Props {
  label?: string;
  selectList?: string[];
  contentClassName?: string;
}

const SelectButton = (props: Props) => {
  const { label, selectList = [], contentClassName } = props;

  return (
    <div className='select-result-button dbd-select-button-container'>
      <span className='select-result-button-label'>{label ? label : ''}</span>
      &nbsp;
      <span className={`select-result-button-content ${contentClassName}`}>
        {
          selectList?.length > 2 ? selectList?.length : selectList?.toString()
        }
      </span>
    </div>
  );
};

export default SelectButton;